import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import AppProvider from "providers/AppProvider";
import { router } from "routes";
import "helpers/initFA";
import { store } from "services/Store";
import { Provider } from "react-redux";
import LoaderManager from "components/common/custom/loader/LoaderManager";
import LoaderProgressManager from "components/common/custom/loader/ProgressManager";
// 👈 import your global loader manager

const container = document.getElementById("main");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <AppProvider>
      <LoaderManager /> {/* 👈 show loader globally */}
      <LoaderProgressManager />
      <RouterProvider router={router} />
    </AppProvider>
  </Provider>
  // </React.StrictMode>
);
